// Module
var code = " <div class=\"react-table-progress\"> </div>";
// Exports
export default code;